var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProwler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "auto",
    height: "auto",
    viewBox: "0 0 128 128",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.895
    },
    fill: "current",
    stroke: "current",
    d: "M44.5 21.5a77.928 77.928 0 0 1 24 5c-1.047 2.93-2.713 5.43-5 7.5 8.858 3.344 17.025 7.844 24.5 13.5.24 2.477-.594 4.644-2.5 6.5A53.393 53.393 0 0 1 72 61.5c-1.059-.13-1.892-.63-2.5-1.5a34.692 34.692 0 0 1 6.5-7.5c.688-.832.521-1.498-.5-2-5.274 5.797-11.607 9.797-19 12a20.216 20.216 0 0 1-6-1.5 62.748 62.748 0 0 1-7-8 66.678 66.678 0 0 0-6-2.5 20.965 20.965 0 0 0-4.5 7 37.882 37.882 0 0 0-6-10l-4.5 9a98.107 98.107 0 0 1-5.5-12 29.112 29.112 0 0 0-2.5 5 55.098 55.098 0 0 1-6.5-6c.813-3.339.646-6.672-.5-10a271.254 271.254 0 0 0 12.5-4c1.226.145 2.393.478 3.5 1 1.34-2.496 3.34-4.329 6-5.5 5.045-1.575 10.045-2.741 15-3.5Zm4 12c-7.478-.352-13.645 2.315-18.5 8a38.9 38.9 0 0 0-5.5-5c5.434.04 10.767-1.127 16-3.5 2.867-.8 5.534-.634 8 .5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.884
    },
    fill: "current",
    stroke: "current",
    d: "M93.5 53.5c5.956-.625 11.289.875 16 4.5a21.681 21.681 0 0 0-7 4.5 407.2 407.2 0 0 1-6.5 14C86.367 84.234 75.534 89.734 63.5 93c3.096 2.029 4.762 4.862 5 8.5a252.2 252.2 0 0 1-24 4 102.624 102.624 0 0 1-14-2.5c-2.796-1.419-4.796-3.585-6-6.5-5.662.846-10.996-.32-16-3.5-1.73-6.856.603-12.022 7-15.5a14.73 14.73 0 0 1 1.5 5c2.23-3 3.896-6.333 5-10a31.158 31.158 0 0 1 4.5 6 34.522 34.522 0 0 0 5.5-6c.68 2.013 2.013 3.346 4 4 6.03-3.443 12.197-3.777 18.5-1a87.02 87.02 0 0 0 28-12c1.099 2.859.599 5.526-1.5 8-2.5 3.833-5.667 7-9.5 9.5C82.668 76.805 89.168 68.639 91 56.5a10.521 10.521 0 0 0 2.5-3Zm-44 40c-1.293.658-2.793.992-4.5 1a63.458 63.458 0 0 1-15-4c-1.79.91-3.623 1.076-5.5.5a27.33 27.33 0 0 1 6-3.5 47.51 47.51 0 0 1 8 4.5 46.958 46.958 0 0 0 11 1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.759
    },
    fill: "current",
    stroke: "current",
    d: "M111.5 60.5c2.064.187 4.064.687 6 1.5 1.507.837 2.007 2.004 1.5 3.5a137.043 137.043 0 0 1-14 7c-.193-5.28 1.973-9.28 6.5-12Z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProwler);
export default __webpack_public_path__ + "static/media/prowler.0a7bf2c5.svg";
export { ForwardRef as ReactComponent };